export const EMPTY_FILTER_FORM={
  businessArea:[],
  startDate: null,
  endDate: null,
  subType: null,
  businessAreaType: [],
  processRunFrom:null, 
  processRunTo:null, 
  processRunBy:null, 
  processId:null
}

export const processData = [
        {
            "id": "PR002",
            "businessAreaType": "SubContractor",
            "subType": "ALC",
            "startDate": "2025-01-01",
            "endDate": "2027-03-31",
            "status": "IN_PROGRESS",
            "sapPostStatus": "IN_PROGRESS",
            "createdBy": "APR213",
            "updatedBy": "APR213",
            "createdOn": "2026-03-11T10:08:45.000+00:00",
            "updatedOn": "2026-03-11T10:08:45.000+00:00"
      },
              {
            "id": "PR003",
            "businessAreaType": "Franchise",
            "subType": "F+EC",
            "startDate": "2025-01-01",
            "endDate": "2027-03-31",
            "status": "COMPLETED",
            "sapPostStatus": "IN_PROGRESS",
            "createdBy": "APR213",
            "updatedBy": "APR213",
            "createdOn": "2026-03-11T10:08:45.000+00:00",
            "updatedOn": "2026-03-11T10:08:45.000+00:00"
      },
        {
            "id": "PR004",
            "businessAreaType": "SINGLE_BUSINESS_AREA",
            "subType": null,
            "startDate": "2025-01-01",
            "endDate": "2027-03-31",
            "status": "IN_PROGRESS",
            "sapPostStatus": "IN_PROGRESS",
            "createdBy": "APR213",
            "updatedBy": "APR213",
            "createdOn": "2026-03-11T10:08:45.000+00:00",
            "updatedOn": "2026-03-11T10:08:45.000+00:00"
      },
           {
            "id": "PR005",
            "businessAreaType": "Franchise",
            "subType": "PURE_FRANCHISE",
            "startDate": "2025-01-01",
            "endDate": "2027-03-31",
            "status": "IN_PROGRESS",
            "sapPostStatus": "IN_PROGRESS",
            "createdBy": "APR213",
            "updatedBy": "APR213",
            "createdOn": "2026-03-11T10:08:45.000+00:00",
            "updatedOn": "2026-03-11T10:08:45.000+00:00"
      },
                 {
            "id": "PR006",
            "businessAreaType": "SubContractor",
            "subType": "PURE_FLIP",
            "startDate": "2025-01-01",
            "endDate": "2027-03-31",
            "status": "IN_PROGRESS",
            "sapPostStatus": "IN_PROGRESS",
            "createdBy": "APR213",
            "updatedBy": "APR213",
            "createdOn": "2026-03-11T10:08:45.000+00:00",
            "updatedOn": "2026-03-11T10:08:45.000+00:00"
      },
];

export const buSubTypeDropDown=[
  {label: "ALC", value:"ALC"},
  {label: "F+EC", value:"F+EC"},
  {label: "None", value:"None"},
]
// utils/processDataFormatter.js

const STATUS_MAP = {
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  FAILED: "Failed"
};

export const COMMON_SUBTYPE ={
  FEC: "F+EC",
  ALC: "ALC"
}

export const FRANCHISE_SUBTYPE_MAP = {
  NONE: "Pure Franchise",
  ...COMMON_SUBTYPE
};
export const SUBCONTRACTOR_SUBTYPE_MAP = {
  NONE: "Pure Flip",
  ...COMMON_SUBTYPE
};

export const BUSINESS_AREA_MAP = {
  SINGLE: "Single Business Area"
};

export const formatStatus = (status = "") =>
  status?STATUS_MAP[status] ||
  status
    .toLowerCase()
    .replace("_", " ")
    .replace(/\b\w/g, c => c.toUpperCase()):"";

export const formatDate = (dateStr) =>
  dateStr ? new Date(dateStr).toLocaleDateString("en-GB") : "";

export const formatDateTime = (dateStr) => {
  if (!dateStr) return { date: "", time: "" };

  const d = new Date(dateStr);

  return {
    date: d.toLocaleDateString("en-GB"),
    time: d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit"
    })
  };
};

export const getTags = ({ businessAreaType, subType }) => {
  const tags = [];

  // Business Area
  tags.push(BUSINESS_AREA_MAP[businessAreaType] || businessAreaType);

  // Subtype
  if (subType) {
    if(businessAreaType=="Franchise")
      tags.push(FRANCHISE_SUBTYPE_MAP?.[subType] || subType);
    if(businessAreaType=="SubContractor" )
      tags.push(SUBCONTRACTOR_SUBTYPE_MAP?.[subType] || subType);
    else if(businessAreaType=="SINGLE"){
      tags.push(COMMON_SUBTYPE?.[subType] || subType)
    }
  }

  return tags;
};

export const formatProcessData = (data = []) => {
  return data.map((item) => {
    const { date, time } = formatDateTime(item.createdOn);

    return {
      id: item.id,
      tags: getTags(item),
      businessArea: "View",
      fromDate: formatDate(item.startDate),
      toDate: formatDate(item.endDate),
      runOnDate: date,
      runOnTime: time,
      runBy: item.createdBy,
      status: formatStatus(item.status),
      emailStatus: item.emailStatus,
      sapPostingStatus: formatStatus(item.sapPostStatus
),
      raw: item
    };
  });
};

export const EMPTY_GENERATE_REPORT_FORM={
    businessType: null,
    subtype: "",
    businessArea: [],
    startDate: "",
    endDate: "",
  }

export const dummyViewData= {
    "recipientType": "DEFAULT",
    "recipients": [
        {
            "businessAreaId": 454,
            "businessAreaName": "DL005",
            "emails": [
                "aakashkorba@aesl.in",
                "sharyarshrajsoni@aesl.in",
                "frc@aesl.in"
            ]
        },
        {
            "businessAreaId": 455,
            "businessAreaName": "HR009",
            "emails": [
                "alcbasti@aesl.in",
                "shashankagarwal@aesl.in",
                "frc@aesl.in"
            ]
        }
    ]
}

